import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'openCloseStore'
})
export class OpenCloseStorePipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Cerrar ahora' : 'Abrir';
  }

}
